import { render, staticRenderFns } from "./MultiLanguage.vue?vue&type=template&id=46e001b1&scoped=true"
import script from "./MultiLanguage.vue?vue&type=script&lang=js"
export * from "./MultiLanguage.vue?vue&type=script&lang=js"
import style0 from "./MultiLanguage.vue?vue&type=style&index=0&id=46e001b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e001b1",
  null
  
)

export default component.exports